import { getEventTracker } from '@libs/eventTracking'
import { WebEventNames } from '@libs/eventTracking/homePage/common'
import {
  getCurrentPagePropertyFor,
  getNextPagePropertyFor,
} from '@libs/eventTracking/eventPropertyUtils'

export function trackFloatingIconEnterEvent(
  currentPageUrl,
  toPageUrl,
) {
  const toPage = {
    pageName: 'event',
    pageUrl: toPageUrl,
  }
  getEventTracker().track({
    name: WebEventNames.FLOATING_ICON_ENTER_EVENT,
    properties: {
      currentPage: getCurrentPagePropertyFor(null, currentPageUrl),
      toPage: getNextPagePropertyFor(toPage),
    },
  })
}
